import { Settings } from 'lucide-react';
import { colors } from '../../styles/colors';

/**
 * Composant bouton de configuration du nombre de consultants
 *
 * @param {number} nombreConsultants - Nombre de consultants actifs
 * @param {Function} onClick - Callback lors du clic
 * @param {boolean} canEdit - Permission de modification
 */
function ConsultantConfigButton({ nombreConsultants, onClick, canEdit = true }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '0.5rem 1rem',
      backgroundColor: colors.secondary.lightGray,
      borderRadius: '0.5rem',
      border: `1px solid ${colors.secondary.lightTeal}`
    }}>
      <span style={{
        fontSize: '0.875rem',
        color: colors.secondary.mediumGray,
        fontFamily: '"Noto Sans", sans-serif'
      }}>
        Consultants actifs:
      </span>
      <span style={{
        fontSize: '1rem',
        fontWeight: 'bold',
        color: colors.primary.teal,
        fontFamily: '"Noto Sans", sans-serif'
      }}>
        {nombreConsultants || 'Non configuré'}
      </span>
      <button
        onClick={() => canEdit && onClick()}
        disabled={!canEdit}
        style={{
          padding: '0.25rem',
          backgroundColor: 'transparent',
          color: colors.primary.teal,
          border: 'none',
          borderRadius: '0.25rem',
          cursor: !canEdit ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          transition: 'all 200ms ease-in-out',
          opacity: !canEdit ? 0.5 : 1
        }}
        onMouseEnter={(e) => canEdit && (e.currentTarget.style.backgroundColor = colors.secondary.lightTeal)}
        onMouseLeave={(e) => canEdit && (e.currentTarget.style.backgroundColor = 'transparent')}
        title={!canEdit ? "Vous n'avez pas les permissions pour configurer" : "Configurer le nombre de consultants"}
      >
        <Settings size={16} />
      </button>
    </div>
  );
}

export default ConsultantConfigButton;
